export type ChargebeeProductName =
  | 'sales-yearly'
  | 'sales-monthly'
  | 'crm-monthly'
  | 'crm-yearly'
  | 'office-user-monthly'
  | 'office-user-yearly'
  | 'sales-2026-monthly'
  | 'sales-2026-yearly'
  | 'operations-monthly'
  | 'operations-yearly'
  | 'additional-team-user-monthly'
  | 'additional-team-user-yearly'
  | 'additional-crew-user-monthly'
  | 'additional-crew-user-yearly'
  | 'additional-crew-user-monthly-legacy'
  | 'additional-crew-user-yearly-legacy'

// Chargebee doesn't allow changing product IDs, so we ended up with
// some slightly messy IDs in dev vs production.
export function getChargebeeProductId(product: ChargebeeProductName): string {
  const isLiveEnvironment = ['master', 'staging'].includes(process.env.DEPLOYMENT_STAGE || '')
  switch (product) {
    case 'sales-yearly':
      return isLiveEnvironment ? 'PaintScout-Sales-USD-Yearly' : 'PaintScout-Sales-Monthly-USD-Yearly'
    case 'sales-monthly':
      return isLiveEnvironment ? 'PaintScout-Sales-USD-Monthly' : 'PaintScout-Sales-Monthly-USD-Monthly'
    case 'crm-monthly':
      return isLiveEnvironment ? 'CRM-Add-On-USD-Monthly' : 'CRM-Add-On-2025-USD-Monthly'
    case 'crm-yearly':
      return isLiveEnvironment ? 'CRM-Add-On-USD-Yearly' : 'CRM-Add-On-2025-USD-Yearly'
    case 'office-user-monthly':
      return 'Office-User-Addon-USD-Monthly'
    case 'office-user-yearly':
      return 'Office-User-Addon-USD-Yearly'
    case 'sales-2026-monthly':
      return isLiveEnvironment ? 'PaintScout-Sales-2026-USD-Monthly' : 'PaintScout-Sales-2026-v2-USD-Monthly'
    case 'sales-2026-yearly':
      return isLiveEnvironment ? 'PaintScout-Sales-2026-USD-Yearly' : 'PaintScout-Sales-2026-v2-USD-Yearly'
    case 'additional-team-user-monthly':
      return 'PaintScout-Team-Seat-USD-Monthly'
    case 'additional-team-user-yearly':
      return 'PaintScout-Team-Seat-USD-Yearly'
    case 'additional-crew-user-monthly':
      return isLiveEnvironment ? 'NOT_IMPLEMENTED' : 'PaintScout-Painter-Account-USD-Monthly'
    case 'additional-crew-user-yearly':
      return isLiveEnvironment ? 'NOT_IMPLEMENTED' : 'PaintScout-Painter-Account-USD-Yearly'
    case 'operations-monthly':
      return 'Operations-Add-On-USD-Monthly'
    case 'operations-yearly':
      return 'Operations-Add-On-USD-Yearly'
    case 'additional-crew-user-monthly-legacy':
      return 'paintscout-view-only-user'
    case 'additional-crew-user-yearly-legacy':
      return 'PaintScout-CrewView-Only-USD-Yearly'
  }
}
